module.exports = __webpack_public_path__ + "components/roadsurfer/static/roadsurfer-1920@2x-669ee1671576608ae8fb7d436718192a.jpg";